import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";

export default function LuxeFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="luxe-footer"
      className="relative bg-[#0a1f5c] text-[#f0e8d8] overflow-hidden"
    >
      {/* Decorative gold border */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#b8964f] to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-10">
          <div className="md:col-span-7">
            <img
              src="https://customer-assets.emergentagent.com/job_mka-company/artifacts/324c7vwg_LOGO%20m.jpg"
              alt="MKA Business Solutions"
              className="h-28 w-auto object-contain mb-8 bg-[#f7f2ea] p-4 inline-block rounded"
              data-testid="luxe-footer-logo"
            />
            <div className="font-fraunces italic text-[#d4b478] text-lg mb-4">
              — For leaders building what's next.
            </div>
            <h2 className="font-serif-display text-5xl sm:text-6xl md:text-7xl leading-[0.95] tracking-tight text-[#f7f2ea]">
              Where <em className="font-serif-editorial italic text-[#d4b478]">strategy</em>
              <br />
              meets <em className="font-serif-editorial italic text-[#d4b478]">soul</em>.
            </h2>
            <Link
              to="/contact"
              data-testid="luxe-footer-cta"
              className="mt-10 inline-flex items-center gap-3 border border-[#d4b478] text-[#d4b478] px-8 py-4 rounded-full font-fraunces text-sm tracking-wide hover:bg-[#d4b478] hover:text-[#0a1f5c] transition-all"
            >
              Begin a Conversation
            </Link>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <div className="font-fraunces italic text-[#d4b478] text-sm mb-4">
                Navigate
              </div>
              <ul className="space-y-3 font-serif-display text-base">
                <li><Link data-testid="luxe-footer-home" to="/" className="luxe-underline">Home</Link></li>
                <li><Link data-testid="luxe-footer-about" to="/about" className="luxe-underline">About</Link></li>
                <li><Link data-testid="luxe-footer-services" to="/services" className="luxe-underline">Services</Link></li>
                <li><Link data-testid="luxe-footer-contact" to="/contact" className="luxe-underline">Contact</Link></li>
              </ul>
            </div>
            <div>
              <div className="font-fraunces italic text-[#d4b478] text-sm mb-4">
                Studio
              </div>
              <ul className="space-y-4 text-sm text-[#f0e8d8]/85 font-fraunces">
                <li className="flex gap-3">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#d4b478]" />
                  <span data-testid="luxe-footer-address">
                    320 N Meridian St<br />Indianapolis, IN 46204
                  </span>
                </li>
                <li className="flex gap-3">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0 text-[#d4b478]" />
                  <a
                    href="mailto:info@mkabusinesssolutions.com"
                    data-testid="luxe-footer-email"
                    className="luxe-underline"
                  >
                    info@mkabusinesssolutions.com
                  </a>
                </li>
                <li className="flex gap-3">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0 text-[#d4b478]" />
                  <span data-testid="luxe-footer-phone">+1 (317) 342-2300</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#f0e8d8]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs tracking-wide text-[#f0e8d8]/60 font-fraunces">
            © {year} MKA Business Solutions. Crafted with intention in Indianapolis.
          </div>
          <div className="font-fraunces italic text-xs text-[#d4b478]">
            mkabusinesssolutions.com
          </div>
        </div>
      </div>
    </footer>
  );
}
